import { Stack, Typography } from "@mui/material";
import { MprcChipChoice, MprcContainer } from "components";
import { ChannelPanelDto } from "generated/CoreApi_v1";
import React from "react";
import { useNavigate } from "react-router";
import { KnowledgePaths } from "routes/KnowledgeRouter";

interface IProps {
    title: string;
    viewData: ChannelPanelDto[];
}

/**
 * Painel lateral padrão para canais
 * @param props
 */
export const PanelChannels: React.FC<IProps> = (props) => {
    const { title, viewData } = props;
    const navigate = useNavigate();

    return viewData.length > 0
        ? (
            <>
                <MprcContainer margin="dense">
                    <Typography variant="h3">{title}</Typography>
                </MprcContainer>
                <Stack direction="row" justifyContent="flex-start" alignContent="flex-start" flexWrap="wrap">
                    {viewData.map(item =>
                        <MprcChipChoice
                            label={item.name}
                            key={item.channelId}
                            selected={false}
                            maxWidth={200}
                            onClick={() => navigate(KnowledgePaths.FeedChannel(item.channelId))}
                        />
                    )}
                </Stack>
            </>
        )
        : null;
};
